var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mainBanner || _vm.loaders.banners
    ? _c(
        "div",
        { staticClass: "dashboard__card dashboard__card--no-min" },
        [
          _vm.loaders.banners ? _c("CardLoading") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dashboard__card-content",
              class: { loadingBlur: _vm.loaders.banners }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "row dashboard__card-body dashboard__card-body--no-min"
                },
                [
                  _vm.mainBanner
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "dashboard__grid dash-banners__content-container"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dash-banners__list h-center-align"
                                },
                                [
                                  _c("NewsBanner", {
                                    attrs: { banner: _vm.mainBanner }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "dashboard__grid dashboard__alert alert alert-warning"
                        },
                        [
                          _c("div", { staticClass: "dashboard__no-data" }, [
                            _vm._v("No Fuel news available")
                          ])
                        ]
                      )
                ]
              ),
              _vm._v(" "),
              _vm.cardBanners.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row dashboard__card-body dashboard__card-body--no-min"
                    },
                    [
                      _vm.cardBanners
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "dashboard__grid dash-banners__content-container"
                            },
                            [
                              _vm.cardBanners.length === 1
                                ? _vm._l(_vm.cardBanners, function(
                                    banner,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dash-banners__list h-center-align"
                                          },
                                          [
                                            _c("NewsBanner", {
                                              key: index,
                                              attrs: { banner: banner }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                                : _vm._l(_vm.cardBanners, function(
                                    banner,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "col-xs-6 dashboard__card-body-col dashboard__card-body-col--bordered"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dash-banners__list h-center-align"
                                          },
                                          [
                                            _c("NewsBanner", {
                                              key: index,
                                              attrs: { banner: banner }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard__card-header" }, [
      _c("div", { staticClass: "dashboard__card-title" }, [
        _vm._v("Fuel News")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dashboard__card-title-icon dashboard__card-title-icon--fuel-news"
        },
        [_c("i", { staticClass: "fas fa-newspaper" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }